import styled from 'styled-components';

import { MapControlButton } from '../../mapControls/StyledMapControls';

/**
 * Positioning is owned by MapControlsCluster; this only anchors the panel to
 * the button it belongs to.
 */
export const SelectorContainer = styled.div`
	position: relative;
	pointer-events: auto;
`;

export const SelectorButton = styled(MapControlButton)`
	/* Operational indicator */
	&::before {
		content: '';
		position: absolute;
		top: 3px;
		right: 3px;
		width: 6px;
		height: 6px;
		background: ${({ theme, $indicatorColor }) => $indicatorColor || theme.colors.green};
		border-radius: 100vw;
	}
`;

/**
 * Opens to the left of the button rather than above it: in a vertical rail,
 * opening upward would cover the controls stacked above.
 *
 * That puts it over the cluster's lateral readout, so the panel is tagged
 * `data-rail-panel` and MapControlsCluster hides the readout while it is open.
 */
export const SelectorPanel = styled.div`
	position: absolute;
	bottom: 0;
	right: calc(100% + 8px);
	/*	background: rgba(${({ theme }) => theme.colors.panelBackgroundRgb}, 0.7); */
	background: ${({ theme }) => theme.colors.background};

	border: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	padding: 12px;
	width: 280px;
	/* Never overflow the viewport on narrow screens. */
	max-width: calc(100vw - 72px);
	animation: slideIn 0.15s ease;
	/* backdrop-filter: blur(16px); */

	@keyframes slideIn {
		from {
			opacity: 0;
			transform: translateX(8px);
		}
		to {
			opacity: 1;
			transform: translateX(0);
		}
	}
`;

export const PanelHeader = styled.div`
	padding-bottom: 8px;
	margin-bottom: 12px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.border};

	display: grid;
	align-items: end;
	grid-template-columns: 1fr auto;
	column-gap: 12px;
`;

export const PanelTitle = styled.div`
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${({ theme }) => theme.colors.textAccent};
`;

export const IndicatorText = styled.p`
	${({ $variant }) => {
		switch ($variant) {
			case 'success':
				return `
				--color: #28a745;
				--background: #28a74520;
			`;
			case 'warning':
				return `
				--color: #ac6820;
				--background: #ac682020;
			`;
			default:
				return `
				--color: #ac2020;
				--background: #ac202020;
			`;
		}
	}}

	margin: 0;
	background: var(--background);
	color: var(--color);
	font-weight: 500;
	font-size: 0.825rem;
	padding: 3px 5px;
	border-radius: 4px;
`;

export const OptionsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const OptionButton = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	border: none;
	border-radius: 4px;
	background: ${({ $selected, theme }) =>
		$selected ? theme.colors.green + '20' : 'transparent'};
	color: ${({ $selected, theme }) => ($selected ? theme.colors.green : theme.colors.textColor)};
	cursor: pointer;
	text-align: left;
	font-size: 0.9rem;
	transition: all 0.1s ease;

	&:hover {
		background: ${({ $selected, theme }) =>
			$selected ? theme.colors.green + '30' : theme.colors.backgroundAccent + '30'};
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;

		&:hover {
			background: transparent;
		}
	}
`;

export const OptionIcon = styled.span`
	display: flex;
	align-items: center;
	width: 20px;
`;
